export const MAX_CONFLICT_RETRIES = 2;

/**
 * Threshold (matching count) above which bulk-delete dispatches asynchronously.
 * Must match `BULK_ACTION_ASYNC_THRESHOLD` in `ahoy/settings.py`.
 */
export const BULK_DELETE_ASYNC_THRESHOLD = 100;
